module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_vm._v("When the pain has passed, there remains the power.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("It, too, is born of pain. Yet from it comes the rush of life unknown to ordinary men. After the bones have bent and reshaped themselves, after the gums have burst and the fangs emerged, after the skull and face have become both less and more than human, after the hair has rippled and scurried in its thousands of frantic pathways across the flesh, after the heart has ceased its crashing and the lungs their straining for new breath, after the scents, sounds, colors and forms unknown to ordinary men have exploded upon the senses and nearly driven the reeling brain mad with their profundity of meaning only the wild can decipher … ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-"
  }, [_vm._v("… there remains the power, and that is the alpha and the omega of the wolf.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 75
// module chunks = 0